import { emitHypotheticalEvent } from "./eventEmitter";

const track = (hypotheticalTracking) => {
    emitHypotheticalEvent({ promo_RecoWhatIf: [hypotheticalTracking] });
};

export default track;
